import { render, staticRenderFns } from "./ChartRender.vue?vue&type=template&id=4be53480&scoped=true&"
import script from "./ChartRender.vue?vue&type=script&lang=js&"
export * from "./ChartRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be53480",
  null
  
)

export default component.exports